import { Link } from "react-router-dom";
import { useState } from "react";
import { FaFacebookF, FaInstagram, FaTwitter, FaWhatsapp, } from "react-icons/fa";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import api from "../api/api";
import FooterLogo from "../assets/images/footer-logo.png";





export default function Footer({ setToast }) {

    const location = useLocation();

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubscribe = async () => {
        if (!email) {
            setToast?.({ message: "Please enter your email" });
            return;
        }

        setLoading(true);

        try {
            const { data } = await api.post("/subscribe", {
                email,
            });

            setToast?.({
                message: data.message || "Subscribed successfully 🎉",
            });

            setEmail("");
        } catch (error) {
            setToast?.({
                message:
                    error.response?.data?.message ||
                    "Subscription failed. Try again.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (

        <footer
            className="
        relative
        bg-gray-950
        text-gray-300
        mt-20
        dark:mt-0

        dark:before:absolute
        dark:before:top-0
        dark:before:left-0
        dark:before:w-full
        dark:before:h-px
        dark:before:bg-gradient-to-r
        dark:before:from-transparent
        dark:before:via-cyan-500/60
        dark:before:to-transparent
    "
        >

            <div className="container mx-auto px-6 py-16">

                {/* NEWSLETTER SECTION */}
                <div className="relative overflow-hidden rounded-3xl mb-12">

                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900"></div>

                    <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/20 rounded-full blur-3xl"></div>
                    <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>

                    <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 p-10 md:p-16 items-center text-white">

                        {/* LEFT */}
                        <div className="text-center md:text-left">
                            <h2 className="text-3xl md:text-4xl font-bold mb-4">
                                Unlock Exclusive UAE Hotel Deals ✨
                            </h2>

                            <p className="text-white/80 text-base md:text-lg">
                                Join thousands of travelers getting instant access to luxury discounts,
                                flash offers & seasonal deals.
                            </p>

                            <div className="mt-6 text-sm text-white/70">
                                No spam • Cancel anytime
                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 md:p-8">

                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email address"
                                className="w-full px-4 py-3 rounded-lg mb-4 
                bg-white text-gray-900 outline-none focus:ring-2 focus:ring-blue-300"
                            />

                            <button
                                onClick={handleSubscribe}
                                disabled={loading}
                                className="w-full bg-white text-blue-600 font-semibold py-3 rounded-lg hover:bg-gray-100 transition disabled:opacity-50"
                            >
                                {loading ? "Subscribing..." : "Subscribe for Deals"}
                            </button>

                            <p className="text-xs text-white/70 text-center mt-3">
                                Join 10,000+ travelers in UAE
                            </p>
                        </div>

                    </div>
                </div>

                {/* MAIN GRID */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 border-b border-gray-800 pb-10">

                    {/* BRAND */}
                    <div>
                        <Link to="/" className="inline-flex items-center">
                            <img
                                src={FooterLogo}
                                alt="Discounted Hotels"
                                className="h-[50px] sm:h-[60px] xl:h-[75px] w-auto object-contain"
                            />
                        </Link>

                        <p className="mt-4 text-sm leading-7 text-gray-400">
                            Find luxury, budget, and beach resorts across Dubai, Abu Dhabi,
                            Sharjah and all UAE cities at the best prices.
                        </p>
                    </div>

                    {/* QUICK LINKS */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Quick Links</h3>

                        <div className="flex flex-col gap-3 text-gray-400">
                            <Link to="/" className="hover:text-white transition">
                                Home
                            </Link>

                            <Link to="/hotels" className="hover:text-white transition">
                                Hotels
                            </Link>

                            <Link to="/services" className="hover:text-white transition">
                                Services
                            </Link>

                            <Link to="/contact-us" className="hover:text-white transition">
                                Contact
                            </Link>
                        </div>
                    </div>

                    {/* SUPPORT */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Support</h3>

                        <div className="flex flex-col gap-3 text-gray-400">
                            <Link to="/faqs" className="hover:text-white transition">
                                FAQ
                            </Link>

                            <Link to="/privacy-policy" className="hover:text-white transition">
                                Privacy Policy
                            </Link>

                            <Link to="/terms-conditions" className="hover:text-white transition">
                                Terms
                            </Link>

                            <Link to="/contact-us" className="hover:text-white transition">
                                Help Center
                            </Link>
                        </div>
                    </div>

                    {/* CONTACT */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Contact</h3>

                        <div className="space-y-3 text-gray-400">

                            <div className="flex items-center gap-2">
                                <FiPhone size={16} />
                                <a href="tel:+971501234567" className="hover:text-white">
                                    +971 50 123 4567
                                </a>
                            </div>

                            <div className="flex items-center gap-2">
                                <FiMail size={16} />
                                <a href="mailto:info@southtravels.com" className="hover:text-white">
                                    info@southtravels.com
                                </a>
                            </div>

                            <div className="flex items-center gap-2">
                                <FiMapPin size={16} />
                                <span>Dubai, UAE</span>
                            </div>

                        </div>

                        <div className="flex gap-4 mt-5">
                            {/* Facebook */}
                            <a
                                href="https://www.facebook.com/SouthTravelsUAE/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                className="hover:text-white transition"
                            >
                                <FaFacebookF size={18} />
                            </a>

                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/southtravels8376/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                                className="hover:text-white transition"
                            >
                                <FaInstagram size={18} />
                            </a>

                            {/* Twitter / X */}
                            <a
                                href="https://twitter.com/SouthTravels"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Twitter"
                                className="hover:text-white transition"
                            >
                                <FaTwitter size={18} />
                            </a>

                            {/* WhatsApp */}
                            <a
                                href="https://api.whatsapp.com/send?phone=971502477593&text=Hi%2C%20I%20would%20like%20to%20inquire%20about%20something.%20I%20found%20your%20website%20at%20https%3A%2F%2Fwww.southtravels.com%2F"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="WhatsApp"
                                className="hover:text-white transition"
                            >
                                <FaWhatsapp size={18} />
                            </a>
                        </div>
                    </div>

                </div>

                <a
                    href="https://wa.me/971502477593?text=Hello%20SouthTravels,%20I%20would%20like%20to%20check%20hotel%20availability,%20pricing,%20and%20current%20offers."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fixed right-0 top-1/2 -translate-y-1/2 z-[9999] group"
                >
                    {/* Soft Glow */}
                    <div className="absolute inset-0 rounded-l-2xl bg-[#25D366] blur-xl opacity-30 animate-pulse"></div>

                    {/* Button */}
                    <div className="relative bg-[#25D366] rounded-l-2xl shadow-2xl px-3 py-5 flex flex-col items-center gap-3 transition-all duration-300 hover:px-5 hover:bg-[#20c45a]">

                        <FaWhatsapp className="text-white text-3xl group-hover:scale-110 transition-transform duration-300" />

                        <span className="[writing-mode:vertical-rl] rotate-180 text-white font-bold tracking-wider text-sm uppercase">
                            Chat Now
                        </span>
                    </div>

                    {/* Tooltip */}
                    <div className="absolute right-20 top-1/2 -translate-y-1/2 bg-slate-900 text-white px-4 py-2 rounded-lg shadow-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none">
                        👋 Need Help? Chat with us
                    </div>
                </a>

                {/* BOTTOM BAR */}
                <div className="pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">

                    <p>
                        © {new Date().getFullYear()} UAE Discounted Hotels. All rights reserved.
                    </p>

                    <p className="mt-2 md:mt-0">
                        Designed for travelers ✈️ UAE Tourism Platform
                    </p>

                </div>

            </div>
        </footer>
    );
}